import { Auth0AuthServiceModule } from 'services/auth/auth0auth.service';
import { ValidateEmailDirectiveModule } from 'directives/validateEmail.directive';
import { LOGIN_REDIRECT_COOKIE } from 'app/constants';

import { CheckoutServiceModule } from '../../checkout.service';
import template from './loginForm.html';
import './loginForm.scss';

export const CheckoutLoginFormModule =
    angular.module('app.components.checkout.components.checkoutLoginForm', [
        Auth0AuthServiceModule,
        ValidateEmailDirectiveModule,
        CheckoutServiceModule
    ]).component('checkoutLoginForm', {
        template,
        bindings: {
            user: '<'
        },
        controller: class CheckoutLoginFormCtrl {
            constructor($window, $cookies, auth0AuthService, checkoutService) {
                'ngInject';

                angular.extend(this, {
                    loading: false,
                    errorMessage: null,
                    $window,
                    $cookies,
                    auth0AuthService,
                    checkoutService
                });
            }

            $onInit() {
            }

            login() {
                this.clearError();

                this.loading = true;
                this.$cookies.put(LOGIN_REDIRECT_COOKIE, this.$window.location.pathname + this.$window.location.search);
                this.auth0AuthService.auth0login(this.loginUser.email);
            }

            inputNeedsAttention(input) {
                return {
                    'v-input--error':
                        (input.$invalid && input.$dirty && input.$touched && input.$invalid) || this.errorMessage
                };
            }

            clearError() {
                this.errorMessage = null;
            }

            setError(message) {
                this.errorMessage = message;
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/checkout/components/loginForm/loginForm.js